import React, { useContext, useEffect, useState } from "react";
import Services from "../network/Services.js";
import "antd/dist/antd.css";
import {Row,Col,Form,Button,Input,Modal,notification,} from "antd";
import config from "./../config.json";
import { UploadOutlined } from "@ant-design/icons";
import { message, Upload } from "antd";
import konsole from "../network/konsole.js";
import { GlobalSpeaker } from "./Seminar/SpeakerInformation.js";
import { UserContext } from "../App.js";
import commonLib from "../control/commonLib.js";
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';


const { TextArea } = Input;

const AddEditSpeaker = ({ hideModal, sendSpeakerListApi, formSpeaker }) => {
  const [form] = Form.useForm();

const { firstNames, getApiDataValue } = useContext(GlobalSpeaker);

  const { setLoader } = useContext(UserContext);
  let splitSpeakerName;
  // let getFriNameAll;
  //   useEffect(()=>{
  //    getFriNameAll = form.getFieldValue('firstName')
  //   },[getFriNameAll])
  //   konsole.log("getFriNameAll",getFriNameAll)

  const [speakerUserId, setSpeakerUserId] = useState("");
  konsole.log("datauserId", speakerUserId);
  const [sendMobNo, setSendMobNo] = useState("");

  const [AddSpeakerForm, setAddSpeakerForm] = useState(true);
  const [AddSpeakerFullName, setAddSpeakerFullName] = useState("");
  // speakerFullNameStatus(AddSpeakerFullName)
  konsole.log("AddSpeakerFullName", AddSpeakerFullName);

  const get1StName = (e) => {
    konsole.log("get1StName", e.target.value || splitSpeakerName);
  };

  const openNotification = (placement, Status) => {
    if (Status == 500) {
      notification.error({
        message: `Error ${Status} `,
        description: "Server Issue! Please try after sometime.",
        placement,
      });
    } else if (Status == 200) {
      notification.success({
        message: `Speaker added successfully`,

        placement,
      });
    }
  };

  const [firstname, setFirstName] = useState("");
  const [lastname, setLastName] = useState("");

  let fullName = firstNames + " " + lastname;

  const [email, setEmail] = useState("");
  const [mobileNumber, setMobileNumber] = useState();
  const [password, setPassword] = useState("Password@123");
  const [packageCode, setPackageCode] = useState(null);

  const [file, setFile] = useState();
  const [createdByuserId, setCreatedByuserId] = useState("");
  const [fileTypeId, setFileTypeId] = useState(15);
  const [fileCategoryId, setFileCategoryId] = useState(1);
  const [fileStatusId, setFileStatusId] = useState(2);

  const [speakeruserId, setspeakeruserId] = useState(0);
  const [speakerProfile, setSpeakerProfile] = useState("");
  const [videoLinkPath, setvideoLinkPath] = useState("");
  const [upsertedBy, setupsertedBy] = useState("");
  const [createdBySessionStorage, setCreatedBySessionStorage] = useState("");
  const [getValueApi, setGetValueApi] = useState({
    videoPath: "",
    userIdSpeaker: "",
    profileSpeaker: "",
    profileUrlSpeaker: "",
    fullNameSpeaker: "",
    imageStatus: 0
  });
  konsole.log("getValueApi", getValueApi);

  getApiDataValue(getValueApi);

  konsole.log("speakerProfile", speakerProfile);

  // sendProfileData(speakerProfile)


  useEffect(() => {
    let upsertedloggedIn = sessionStorage.getItem("loggedUserId");
    setupsertedBy(upsertedloggedIn);
    konsole.log("upsertedloggedIn",upsertedloggedIn)

    let createdByLocalSession = commonLib.getObjFromStorage('stateObj')
    setCreatedBySessionStorage(createdByLocalSession.userId)
    
    
    splitSpeakerName = firstNames.split(" ")
    konsole.log("splitSpeakerName",splitSpeakerName)
    
    form.setFieldsValue({
      firstName: splitSpeakerName[0],
      // lastname: splitSpeakerName[1].charAt(0).toUpperCase() +  splitSpeakerName[1].slice(1),
    });

    if(splitSpeakerName.length ==2){
      form.setFieldsValue({
        lastname: splitSpeakerName[1].charAt(0).toUpperCase() +  splitSpeakerName[1].slice(1),      });

    }

  }, [firstNames]);

  konsole.log("CheckMobNo", sendMobNo);
  const handleSubmit = (values) => {
    const InpData = values;
    const Inputs = {
      firstName: InpData.firstName,
      lastname: InpData.lastname,
      Profile: InpData.Profile,
      VideoLink: InpData.VideoLink,
      email: InpData.email,
      phone: InpData.phone,
    };

    konsole.log(
      "SpeakerAllInputData",
      Inputs.firstName + " " + Inputs.lastname
    );
    let UserFullName = Inputs.firstName + " " + Inputs.lastname;
    setAddSpeakerFullName(UserFullName);
    setAddSpeakerForm(Inputs.values);
    

    let MobNoConcat = "+" + mobileNumber;
    konsole.log("MobNoConcat", MobNoConcat);
    setSendMobNo(MobNoConcat);

    // const speakerRegisterApi = Services.getCoOrdinatorAddDetails(2, 7, Inputs.firstName, Inputs.lastname, 1, sendMobNo, createdBySessionStorage, email, createdBySessionStorage, createdBySessionStorage)
    // setLoader(true)
    // speakerRegisterApi
    //   .then((res) => {
    //     konsole.log("AddSpeakerRes", res)
    //     konsole.log('responseCorrect1', res.data.data.user.createdBy)
    //     // checkingApi(res.data.data.user.userId);
    //     fileupload(res.data.data.createdBy,res.data.data.user.userId);

    //   })
    //   .catch((error) => {
    //     konsole.error("errorDetails", error)
    //   }).finally(()=>{
    //     setLoader(false)
    //     // getdefaultValue("")
    //   })
    setLoader(true)
    let subtenantId = sessionStorage.getItem("subtenantId");
    const jsonObjData = {
      subtenantId: subtenantId,
      signUpPlateform: config.AOADMIN,
      createUserCredentials: true,
      createdBy: createdBySessionStorage,
      user: {
        roleId: 7,
        firstName: Inputs.firstName,
        lastName: Inputs.lastname,
        emailAddress: email,
        userName: email,
        countryCode: codeMobileNo,
        mobileNumber: mobileNumber?.startsWith(codeMobileNo.replace("+", "")) ? mobileNumber?.slice(codeMobileNo.replace("+", "").length) : mobileNumber,
        // password: "stringst",
        packageCode: null,
        activateUser: false,
        autoConfirmEmail: false,
        autoConfirmMobile: false,
      },
    };


    const speakerRegisterApi = Services.subtenantCreateUser(jsonObjData);
    speakerRegisterApi
      .then((res) => {
        konsole.log("speakerresponse", res);

        if(file !== undefined && file !== null && file !== ""){

          fileupload(res.data.data.createdBy, res.data.data.userId);
        }else{
          postspekaeruser(null, res.data.data.userId);
        }



      })
      .catch((err) => {
        konsole.log("errrSpeaker", err.response.data.messages[1].split(" ").splice(0,5).join(" "));
        if(err.response.data.messages[0] == "ALREADY_REGISTERED"){
          message.error(err.response.data.messages[1])
        }
      }).finally(()=>{
        setLoader(false)
      })
  };
  const fileupload = (createdByuserId, datauserid) => {
    const fileuploadCallApi = Services.postfileuploadspeaker(
      file,
      upsertedBy,
      createdByuserId,
      fileTypeId,
      fileCategoryId,
      fileStatusId
    );
    fileuploadCallApi
      .then((res) => {
        konsole.log("responsefileupload", res);
        // setspeakerImageId(res.data.data.fileId)
        konsole.log("response", res.data.data.fileId);
        postspekaeruser(res.data.data.fileId, datauserid);
      })
      .catch((error) => {
        konsole.error("errrr", error);
      }).finally(()=>{
        setLoader(false)
      })
  };

  const postspekaeruser = (speakerImageId, createdByuserId) => {
    // const checkingApi = (SpeakerDetailsUserId,speakerImageId) => {
      
    const postspeakerupsertCallApi = Services.postspeakerupsertuser(
      0,
      createdByuserId,
      speakerProfile,
      videoLinkPath,
      speakerImageId,
      "Done",
      true,
      upsertedBy
    );
    postspeakerupsertCallApi
      .then((res) => {
        konsole.log("responsepostspeakerupsertCallApi", res);
        konsole.log("UpsetSpeaker", res.data.data.speakers[0].videoLinkPath);
        konsole.log("UpsetSpeaker", res.data.data.speakers[0].speakerProfile);
        konsole.log(
          "UpsetSpeaker",
          res.data.data.speakers[0].speakerProfileUrl
        );
        konsole.log("UpsetSpeaker", res.data.data.speakers[0].speakerUserId);
        konsole.log("UpsetSpeaker", res.data.data.speakers[0].speakerFullName);
        setGetValueApi({
          videoPath: res.data.data.speakers[0].videoLinkPath,
          userIdSpeaker: res.data.data.speakers[0].speakerUserId,
          profileSpeaker: res.data.data.speakers[0].speakerProfile,
          profileUrlSpeaker: res.data.data.speakers[0].speakerProfileUrl,
          fullNameSpeaker: res.data.data.speakers[0].speakerFullName,
          imageStatus: 1
        });

        hideModal(false);
        form.resetFields();
        setLoader(false);
        openNotification("topRight", res.status);
      })
      .catch((error) => {
        konsole.log("upsertError", error);
      })
      .finally(() => {
        setLoader(false);
      });
  };

  // ......................................................................

  const props = {
    beforeUpload: (file) => {
      const isPNG = file.type === "image/png";

      if (!isPNG) {
        message.error(`${file.name} is not a png file`);
        return;
      }

      return false;
    },

    onChange(info) {
      konsole.log("fileList", info);
      konsole.log("fileListFile", info.file);
      setFile(info.file);

      if (info.file.status === "done") {
        message.success(`${info.file.name} file uploaded successfully`);
      }
    },
  };

  // ......................................................................

  const [codeMobileNo, setCodeMobileNo] = useState("+1");
  const [selectedCountry, setSelectedCountry] = useState("us");

  const onChangePhone = (value, country) => {
    const dialCode = country?.dialCode || "1";
    setCodeMobileNo("+" + dialCode);
    setSelectedCountry(country?.countryCode || "us");
    setMobileNumber(value);
    form.setFieldsValue({ PhoneNumberAddEditSpeaker: value });
  };

  return (

      <Form
        form={form}
        name="basicform"
        layout="vertical"
        onFinish={handleSubmit}
        initialValues={{ remember: true, prefix: "91" }}
      >
         <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '10px 10px 12px 14px', borderBottom: '1px solid #bfbfbf' }}>
          <p style={{ fontSize: '16px', fontWeight: '700', color: '#333333', margin: 0 }}>
            Add Speaker
          </p>
          <span onClick={() => hideModal(false)} style={{ cursor: 'pointer', fontSize: '25px', color: '#333333', lineHeight: 1, padding: '2px 6px' }}>×</span>
        </div>

        
        <div style={{
              maxHeight: 'calc(100vh - 80px)',
          overflowY: 'auto', padding:"14px"
            }}>
        <Form.Item className=""
          label="First Name"
          name="firstName"
          rules={[
            {
              pattern: new RegExp(/^[a-zA-Z]*$/),
              message: "No Space or Special Characters Allowed",
            },
            { required: true, message: "Please input your first Name!" },
          ]}
        >
          <Input onChange={get1StName }  onInput={e => e.target.value = e.target.value.charAt(0).toUpperCase() + e.target.value.slice(1)}/>
        </Form.Item>

        <Col xs={24} lg={24}>
          <Form.Item
            label="Last Name"
            name="lastname"
            rules={[
              {
                pattern: new RegExp(/^[a-zA-Z]*$/),
                message: "No Space or Special Characters Allowed",
              },
              { required: true, message: "Please input your last name!" },
            ]}
          >
            <Input onChange={(e) => setLastName(e.target.value)} onInput={e => e.target.value = e.target.value.charAt(0).toUpperCase() + e.target.value.slice(1)}/>
          </Form.Item>
        </Col>

      
        <Form.Item
          label="Profile"
          name="Profile"
          rules={[
            {message: "Please enter your Profile Details" },
          ]}
          
        >
         
          <TextArea
            rows={2}
            placeholder="Speaker Profile"
            minLength={6}
            onChange={(e) => setSpeakerProfile(e.target.value)}
            onInput={e => e.target.value = e.target.value.charAt(0).toUpperCase() + e.target.value.slice(1)}/>
        </Form.Item>

        <Form.Item
          name="VideoLinkAddEditSpeaker"
          label=" Link"
          rules={[
            {
              pattern: new RegExp(
                "https?://(?:www.|(?!www))[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9].[^s]{2,}|www.[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9].[^s]{2,}|http?://(?:www.|(?!www))[a-zA-Z0-9]+.[^s]{2,}|www.[a-zA-Z0-9]+.[^s]{2,}"
              ),
              message: "Please enter valid url with http!",
            },
            { required: true, message: "Please input link!" },
          ]}
        >
          <Input
            placeholder="https://"
            onChange={(e) => setvideoLinkPath(e.target.value)}
          />
        </Form.Item>

        <Form.Item
          name="emailAddEditSpeaker"
          label="Email"
          onChange={(e) => setEmail(e.target.value)}
          rules={[
            {
              pattern: new RegExp("[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,3}$"),
              message: "Please enter correct email address",
            },
            {
              required: true,
              message: "Please input your E-mail!",
            },
          ]}
        >
          <Input />
        </Form.Item>

        <Form.Item name="phoneAddEditSpeaker" label="Cell Number">
          <PhoneInput
            country={selectedCountry}
            preferredCountries={["us"]}
            value={mobileNumber}
            onChange={onChangePhone}
            countryCodeEditable={false}
            disableCountryGuess={true}
            inputStyle={{ width: "100%", height: "44px" }}
            containerStyle={{ width: "100%" }}
          />
        </Form.Item>

        {/* <Upload
          onChange={(response) => {
            if (response.file.status !== 'uploading') {
              konsole.log(response.file, response.fileList);
            }
            if (response.file.status === 'done') {
              message.success(`${response.file.name} 
                               file uploaded successfully`);
            } else if (response.file.status === 'error') {
              message.error(`${response.file.name} 
                             file upload failed.`);
            }
          }}
        >
          <FormItem label="Profile Image"
            name="Profile Image">
            <Button>Upload File</Button>
          </FormItem>
        </Upload> */}

        {/* <Upload {...props}>
          <Button icon={<UploadOutlined />}  >Upload png only</Button>
        </Upload> */}
        {/* ............................................................................................................. */}
        <Form.Item
          name="PngImgUpload"
          className="mt-3"
          // rules={[
          //   {
          //     required: true,
          //     message: "Please Upload Image",
          //   },
          // ]}
        >
          <Upload {...props}>
            <Button className="Upload_Btn" icon={<UploadOutlined />}>Upload png only</Button>
          </Upload>
        </Form.Item>

          <div className="d-flex justify-content-end mt-2">
          <Button className="text-white" htmlType="submit" style={{backgroundColor:"#720c20", height:"44px", borderRadius:"2px", minWidth:"90px"}}>
            ADD
          </Button>
        </div>
      </div>
      </Form>
  );
};

export default AddEditSpeaker;
